<div class="image-box">
  @if (gif()) {
    <picture
      class="gif-height">
      @if (gifMobile()) {
        <source
          media="(max-device-width: 640px)"
          [srcset]="gifMobileUrl()" />
      }
      <img [src]="gifUrl()"
        [attr.alt]="altTagText()"
        [loading]="willLazyLoad() ? 'lazy' : 'eager'" />
    </picture>
  }
  @if (image() && !gif()) {
    <picture>
      @if (mobileImg()) {
        <source
          [srcset]="mobileImgUrl()"
          media="(max-width: 768px)" />
      }
      <img [src]="imageUrl()" class="loaded"
        [attr.alt]="altTagText()"
        [loading]="willLazyLoad() ? 'lazy' : 'eager'" />
    </picture>
  }
</div>
